var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1226.4 1226.4",
    style: {
      enableBackground: "new 0 0 1226.4 1226.4"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M727.3,519.3L1174.1,0h-105.9L680.3,450.9L370.5,0H13.2l468.5,681.8L13.2,1226.4h105.9l409.6-476.2l327.2,476.2 h357.3L727.3,519.3L727.3,519.3z M582.4,687.8l-47.5-67.9L157.2,79.7h162.6l304.8,436l47.5,67.9l396.2,566.7H905.7L582.4,687.8 L582.4,687.8z"
  })));
};
export default SvgTwitter;